import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await apiClient.post("/contact", payload);
  return data;
}

export async function submitQuote(payload) {
  const { data } = await apiClient.post("/quote", payload);
  return data;
}

export async function submitCareer(formData) {
  const { data } = await axios.post(`${API}/careers/apply`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function submitWalkthrough(payload) {
  const { data } = await apiClient.post("/walkthrough", payload);
  return data;
}

export async function submitFeedback(payload) {
  const { data } = await apiClient.post("/feedback", payload);
  return data;
}
